import { Box } from '@mui/material';
import React from 'react';
import Icon, { AvailableIconTypes } from '@ui/Icon';
import Typography from '@ui/Typography';

interface CardFooterProps {
  icon: AvailableIconTypes;
  text: string;
  slots?: {
    menu?: React.ReactNode;
  };
}

const CardFooter = (props: CardFooterProps) => {
  const { icon, text, slots } = props;

  return (
    <Box display="grid" gridAutoFlow="column" gridTemplateColumns="1fr">
      <Box
        display="grid"
        gridAutoFlow="column"
        justifyContent="start"
        style={{ gap: 8 }}
        alignItems={'center'}
      >
        <Icon type={icon} />
        <Typography variant="pSm" color="secondary">
          {text}
        </Typography>
      </Box>
      {slots?.menu && slots.menu}
    </Box>
  );
};

export default CardFooter;
